import React, {useState, useEffect} from "react"
import {useHistory} from "react-router-dom"
import {
    Container,
    Row,
    Col,
    Card,
    CardImg,
    CardTitle,
    Button,
    Badge
} from "reactstrap"
import AutoSizer from 'react-virtualized-auto-sizer'
import axios from '../../axiosConfig'
import IndexHeader from 'components/Header/Header'

function Projects() {

    const history = useHistory()

    function selectProject(projectID) {
        history.push('/project/' + projectID)
    }

    const [data,
        setData] = useState({projects: []})
    useEffect(() => {
        const fetchData = async() => {
            const result = await axios('.json',)
            setData(result.data)
        }
        fetchData()
    }, [])

    return (
        <>
            <div className="section">
                <IndexHeader/>
            </div>
            <div className="section-basic mb-5">
                <Container>
                    <Row className="justify-content-center">

                    
                        {Object
                            .entries(data.projects)
                            .sort((a, b) => {
                                if(a[1].name < b[1].name) { return -1 }
                                if(a[1].name > b[1].name) { return 1 }
                                return 0;
                            })
                            .sort((a, b) => {
                                if(a[1].promoted) { return -1 }
                                return 0;
                            })
                            .map(([key, item]) => {
                                return (
                                    <Col key={key} className="section-story-overview" lg="4" md="6">
                                        <Card style={{ minHeight: "100%" }}>
                                        
                                            <Row>
                                                <Col>
                                                    <CardTitle tag="h3" className="pt-3 pl-3 pb-1">{item.name ? item.name : 'Untitled Project'} 
                                                    {item.promoted ? (<Badge style={{float: "right", margin: "10px"}} color="info">PROMOTED</Badge>) : null}
                                                    </CardTitle>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col className="col-sm-4">
                                                    <CardImg className="pl-2" src={item.picture ? (item.picture) : (require('assets/img/logo.png'))} alt="Logo"/>
                                                    
                                                </Col>
                                                <Col className="col-sm-8" style={{height: "110px", top: -5, left: -30}}>
                                                    <AutoSizer>
                                                        {({width}) => {
                                                            return (
                                                                <p className="pl-2" style={{width: width + 20 + "px", fontSize: "14px"}}>
                                                                    {item.shortDescription ? item.shortDescription : "Short description of Capstone Project"}
                                                                </p>
                                                            )
                                                        }}
                                                    </AutoSizer>
                                                </Col>
                                            </Row>
                                            <Button
                                                color="info"
                                                onClick={() => selectProject(key)}
                                                style={{
                                                    position: "absolute",
                                                    bottom: 5,
                                                    right: 15,
                                                }}
                                            >More <i style={{padding: "0 0 0 10px"}} className="now-ui-icons arrows-1_minimal-right" /></Button>
                                        </Card>
                                    </Col>
                                )
                            })}
                    </Row>
                </Container>
            </div>
        </>
    )
}

export default Projects
